import React from 'react';

const FilterInput = ({ 
  value, 
  onChange, 
  onKeyDown, 
  placeholder, 
  disabled, 
  ariaLabel,
  description
}) => {
  return (
    <div className="filter-input-container">
      <input
        type="text"
        className="filter-input"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        disabled={disabled}
        aria-label={ariaLabel}
        aria-describedby={description ? 'filter-description' : undefined}
      />
      
      {/* Description text for guidance */}
      {description && (
        <div id="filter-description" className="filter-description">
          {description}
        </div>
      )}
    </div>
  );
};

export default FilterInput;